/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_VintageInputs */

const en_field_vintage = /** @type {(inputs: Field_VintageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vintage (Year)`)
};

const es_field_vintage = /** @type {(inputs: Field_VintageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosecha (Año)`)
};

const fr_field_vintage = /** @type {(inputs: Field_VintageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Millésime (Année)`)
};

const de_field_vintage = /** @type {(inputs: Field_VintageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jahrgang`)
};

const ja_field_vintage = /** @type {(inputs: Field_VintageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヴィンテージ (年)`)
};

const zh_field_vintage = /** @type {(inputs: Field_VintageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年份`)
};

const ar_field_vintage = /** @type {(inputs: Field_VintageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سنة التعتيق`)
};

const id_field_vintage = /** @type {(inputs: Field_VintageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tahun Pembuatan`)
};

const it_field_vintage = /** @type {(inputs: Field_VintageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annata`)
};

const ru_field_vintage = /** @type {(inputs: Field_VintageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Год урожая (Винтаж)`)
};

const pt_field_vintage = /** @type {(inputs: Field_VintageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Safra (Ano)`)
};

const ko_field_vintage = /** @type {(inputs: Field_VintageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`빈티지 (생산 연도)`)
};

/**
* | output |
* | --- |
* | "Vintage (Year)" |
*
* @param {Field_VintageInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_vintage = /** @type {((inputs?: Field_VintageInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_VintageInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_vintage(inputs)
	if (locale === "es") return es_field_vintage(inputs)
	if (locale === "fr") return fr_field_vintage(inputs)
	if (locale === "de") return de_field_vintage(inputs)
	if (locale === "ja") return ja_field_vintage(inputs)
	if (locale === "zh") return zh_field_vintage(inputs)
	if (locale === "ar") return ar_field_vintage(inputs)
	if (locale === "id") return id_field_vintage(inputs)
	if (locale === "it") return it_field_vintage(inputs)
	if (locale === "ru") return ru_field_vintage(inputs)
	if (locale === "pt") return pt_field_vintage(inputs)
	return ko_field_vintage(inputs)
});